import client from '@stores/apollo'
import gql from 'graphql-tag'
import { AssignmentPlanFragment } from '@api/fragments'
import { IAssignmentPlan } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface CreateAssignmentPlanInput {
  scenarioGroupId: string
}

interface IPayload {
  createAssignmentPlan: {
    assignmentPlan: IAssignmentPlan
  }
}

const mutateHandler = handleFetchResult<IPayload, IAssignmentPlan>({
  handler: (data) => data.createAssignmentPlan.assignmentPlan,
  name: 'Assignment Plan',
})

export default function create(input: CreateAssignmentPlanInput): Promise<IAssignmentPlan> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation CreateAssignmentPlan($input: CreateAssignmentPlanInput!) {
    createAssignmentPlan(input: $input) {
      assignmentPlan {
        ...AssignmentPlanFragment
      }
    }
  }
  ${AssignmentPlanFragment}
`
